import styled from 'styled-components';

import { Collapse } from '@cognite/cogs.js';

export const StyledCollapse = styled(Collapse)`
  overflow: auto;
`;
